import React, { Fragment } from 'react';
import { useFieldArray } from 'react-hook-form';
import styled from 'styled-components';
import { getScrollBarStyles } from '../../../../../../config/styles';
import useMeasureFilterFormContext from '../utils/useMeasureFilterFormContext';
import { defaultSingleMeasureFilter } from '../types';
import AddMeasureFilterMenu from './AddMeasureFilterMenu';
import SingleMeasureFilter from './SingleMeasureFilter';
import { IMeasureFilterValue } from '../../../../../../redux/slices/oldBuilder';
import { theme } from '../../../../../../styles/theme';

interface IProps {
  options: IMeasureFilterValue[];
}

const Container = styled.div`
  padding-top: 12px;
  padding-right: 6px;
  padding-left: 12px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding-right: 6px;
  max-height: 680px;
  overflow-y: auto;
  ${getScrollBarStyles(4)};
`;

const Operator = styled.div`
  align-self: center;
  display: inline-block;
  padding: 2px 4px;
  border-radius: 2px;
  font-weight: 500;
  text-transform: uppercase;
  background-color: ${theme.colors.mainBlue};
  line-height: normal;
  color: #fff;
`;

const ActionsContainer = styled.div`
  padding-top: 12px;
  padding-right: 12px;
  padding-left: 12px;
`;

const MeasureFilterFormFilters = ({ options }: IProps) => {
  const { control } = useMeasureFilterFormContext();

  const {
    fields: filters,
    append: addFilter,
    remove: removeFilter,
  } = useFieldArray({
    name: 'filters',
    control,
  });

  const handleAddFilter = (measureKey: string) => {
    addFilter({ ...defaultSingleMeasureFilter, measureKey });
  };

  const allowAddFilters = filters.length < options.length;
  const allowRemoveFilters = filters.length > 1;

  return (
    <>
      <Container>
        <Wrapper>
          {filters.map((filter, filterIndex) => (
            <Fragment key={filter.id}>
              {filterIndex > 0 && <Operator>And</Operator>}
              <SingleMeasureFilter
                filterIndex={filterIndex}
                onRemove={
                  allowRemoveFilters
                    ? () => removeFilter(filterIndex)
                    : undefined
                }
              />
            </Fragment>
          ))}
        </Wrapper>
      </Container>
      {allowAddFilters && (
        <ActionsContainer>
          <AddMeasureFilterMenu options={options} onAdd={handleAddFilter} />
        </ActionsContainer>
      )}
    </>
  );
};

export default MeasureFilterFormFilters;
